/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  ExportProductionSitesForBrandsMutationResponse,
  ExportProductionSitesForBrandsQueryParams,
} from "../types/ExportProductionSitesForBrands.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const exportProductionSitesForBrandsMutationKey = () =>
  [{ url: "/v1/production-site/export-production-sites-for-brands" }] as const

export type ExportProductionSitesForBrandsMutationKey = ReturnType<
  typeof exportProductionSitesForBrandsMutationKey
>

/**
 * @summary Export production sites for a brand as CSV
 * {@link /v1/production-site/export-production-sites-for-brands}
 */
export async function exportProductionSitesForBrands(
  params?: ExportProductionSitesForBrandsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ExportProductionSitesForBrandsMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/production-site/export-production-sites-for-brands`,
    params,
    ...requestConfig,
  })
  return res
}

export function exportProductionSitesForBrandsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = exportProductionSitesForBrandsMutationKey()
  return mutationOptions<
    ResponseConfig<ExportProductionSitesForBrandsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportProductionSitesForBrandsQueryParams },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ params }) => {
      return exportProductionSitesForBrands(params, config)
    },
  })
}

/**
 * @summary Export production sites for a brand as CSV
 * {@link /v1/production-site/export-production-sites-for-brands}
 */
export function useExportProductionSitesForBrands<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ExportProductionSitesForBrandsMutationResponse>,
      ResponseErrorConfig<Error>,
      { params?: ExportProductionSitesForBrandsQueryParams },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? exportProductionSitesForBrandsMutationKey()

  const baseOptions = exportProductionSitesForBrandsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ExportProductionSitesForBrandsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportProductionSitesForBrandsQueryParams },
    TContext
  >

  return useMutation<
    ResponseConfig<ExportProductionSitesForBrandsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportProductionSitesForBrandsQueryParams },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ExportProductionSitesForBrandsMutationResponse>,
    ResponseErrorConfig<Error>,
    { params?: ExportProductionSitesForBrandsQueryParams },
    TContext
  >
}
